import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

var Circle = function Circle(_ref) {
  var cx = _ref.cx,
    cy = _ref.cy,
    r = _ref.r,
    fill = _ref.fill,
    id = _ref.id,
    theme = _ref.theme;
  return /*#__PURE__*/React.createElement("circle", {
    cx: cx,
    cy: cy,
    r: r,
    fill: fill || theme.constellation.colors.blue500,
    id: id,
    className: "rd3-linechart-circle"
  });
};
Circle.propTypes = process.env.NODE_ENV !== "production" ? {
  cx: PropTypes.number,
  cy: PropTypes.number,
  fill: PropTypes.string,
  r: PropTypes.number,
  id: PropTypes.string,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  theme: PropTypes.object
} : {};
var Circle$1 = withTheme(Circle);

export { Circle$1 as default };
